/**
 * TODO: Change attribute changing to single style instead of multiple attribute calls to avoid reflowing.
 */
import Utils from "../utils";
import RenderManager from "../rendering/render-manager";
import QuizManager from "../quizes/quiz-manager";
import QuizTitles from "../quizes/quiz-titles";
import showModal from "../show-modal";
import RewardScreens from "../rewardScreens/rewardScreens";
import Analytics from "../analytics";
import { fire } from "../utils/events";
import SlideManager from "../utils/slide-manager";
import getLetterbox from "../helpers/get-letterbox";
import { MeshLabel, LiveLabel } from "../labels/live/helpers/mesh-label-data";


// http://owumaro.github.io/text-stroke-generator/
function createShadow(strokeSize, strokeColor) {
    let textShadow = "";

    function appendShadow(x, y, col) {

        // compute new text-shadow property
        textShadow = (!textShadow ? "" : (textShadow + ", ")) + x + 'px ' + y + 'px ' + col;
    }

    for (let angle = 0; angle < 2 * Math.PI; angle += 1 / strokeSize) {
        appendShadow(Math.cos(angle) * strokeSize, Math.sin(angle) * strokeSize, strokeColor);
    }

    return textShadow;
}

function getShadowString(size, color) { return createShadow(size, color); }

function createClass(name, rules) {
    const style = document.createElement('style');
    style.type = 'text/css';
    document.getElementsByTagName('head')[0].appendChild(style);
    if (!(style.sheet || {}).insertRule)
        (style.styleSheet || style.sheet).addRule(name, rules);
    else
        style.sheet.insertRule(name + "{" + rules + "}", 0);

    return style;
}

/**
 * @type {TextLiveLabel}
 */
let TEXT_ELEMENT = null;
const CHAR_SIZES = {};
let FONT_HEIGHT = 0;
const tmpColor = new THREE.Color();
const DISABLE_DISTANCE_CHECK = true;
const USE_CSS_STYLE = false;
const NAMESPACE_SVG = "http://www.w3.org/2000/svg"; //DevSkim: ignore DS137138

/**
 *
 * @param {MouseEvent} event
 */
function stopEvent(event) {
    if (Q3.editMode && Q3.activeEditorTab !== "AddLabels") {
        RenderManager.domElement.click(event);
        return;
    }

    Q3.controls.enabled = false;

    /**
     * @type {HTMLElement}
     */
    const root = RenderManager.overlay2d;

    const _class = event.target.getAttribute("class") || "";
    if (_class.indexOf("color-picker") !== -1)
        return;

    if (root.contains(event.target)) {
        if (event.stopPropagation) {    // standard
            event.stopPropagation();
        } else {    // IE6-8
            event.cancelBubble = true;
        }

        dispatchEvent(new Event(event.type, {
            target: event.target
        }));

        return false;
    }
}

class TextLiveLabel {
    constructor(liveLabel, options, uuid) {
        this.uuid = uuid;

        const name = btoa(this.uuid);

        if (USE_CSS_STYLE) {
            const style = this._styleClass = createClass(`#${name}`, "display: none; left: 0; top: 0");
            style.id = this.uuid;

            this._sheetRules = (style.sheet.cssRules || style.sheet.rules)[0].style;
        }

        this.y = options.y;
        this.x = options.x;
        this.color = options.color;
        this.border = options.border;
        this.fontSize = options.fontSize;
        this.fontWeight = options.fontWeight;
        this.textAlign = options.textAlign;
        this.content = options.content || "";
        this._highlighted = false;

        this.backgroundOpacity = options.backgroundOpacity === undefined ? 0.4 : options.backgroundOpacity;
        this.backgroundColor = options.backgroundColor === undefined ? "#000000" : options.backgroundColor;
        this.backgroundRadius = options.backgroundRadius === undefined ? 15 : options.backgroundRadius;
        this.paddingHorizontal = options.paddingHorizontal === undefined ? 0.1 : options.paddingHorizontal;
        this.paddingVertical = options.paddingVertical === undefined ? 0.35 : options.paddingVertical;

        this.isVisible = true;

        this.type = "2DObject";

        this.domElement = document.createElement("div");

        const svg = this._svg = document.createElement("div");
        const g = this._g = document.createElement("div");
        this._textElement = document.createElement("div");
        this._textElement.classList.add("label-text");
        const textHolder = document.createElement("div");
        const iconHolder = document.createElement("div");
        iconHolder.style.pointerEvents = "none";
        this._icon = iconHolder;
        textHolder.style.display = "inline-flex";
        textHolder.style.display = "inline-flex";
        iconHolder.classList.add("info-icon");

        g.style.borderRadius = "15px";
        g.style.border = "1px solid";
        g.style.borderColor = "transparent";
        g.style.lineHeight = "1";

        g.style.textAnchor = "middle";
        g.style.display = "flex";
        g.style.flexWrap = "wrap";
        g.style.alignItems = "center";
        g.style.maxWidth = "10em";
        g.style.transition = "background .2s";
        textHolder.appendChild(this._textElement);

        g.appendChild(textHolder);
        svg.appendChild(g);
        this.domElement.appendChild(svg);

        this.domElement.style.display = "inline-block";
        this.domElement.style.position = "absolule";
        this.domElement.id = name;
        this.domElement.classList.add("livelabel");
        this.domElement.addEventListener("mousedown", stopEvent, false);
        this.domElement.addEventListener("mouseup", function () {
            Q3.controls.enabled = true
        }, false);
        this.domElement.addEventListener("mousedown", () => {
            if (!Q3.editMode || Q3.assetMode === "edit_hierarchy") {
                Q3.Events.fire("live_label_click", this.uuid);
            }
        });

        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.distanceMin = options.distanceMin || 5;
        this.distanceMax = options.distanceMax || 10;
        this.fontSizeMin = options.fontSizeMin === undefined ? options.fontSize : options.fontSizeMin;
        this.hoverText = options.hoverText;
        this.globalVisibility = false;
        this.visibilityType = "always";

        this._liveLabel = liveLabel;
        this._lastFontSize = 0;

        this.textScale = options.textScale || "small";

        this._container = document.createElement("div");
        const foreignObject = this._foreignObject = liveLabel.foreignObject = document.createElement("div");

        foreignObject.appendChild(this._container);

        this._foreignObject.style.display = "none";
        this.domElement.appendChild(foreignObject);

        this._icon.addEventListener("click", () => {
            if (Q3.editMode && !Q3.labels.live.isDrawingRegion) {
                if (Q3.isSelecting2dObject) return;

                Q3.selected = this._liveLabel;
                fire("selectchange");
                fire("editLabelContent", this._liveLabel);
            }
            else { this._onClick.call(this); }
        });

        this.domElement.addEventListener("click", this._onClick.bind(this), false);

        if (this._btnElement) {
            this._btnElement.addEventListener("click", this._onClick.bind(this), false);
        }

        this.domElement.addEventListener("mouseover", this._onMouseOver.bind(this), false);

        const mouseOut = ["mouseout"];

        mouseOut.forEach(x => {
            this.domElement.addEventListener(x, this._onMouseLeave.bind(this), false);
        });

        this._pathCallouts = [
            document.createElementNS(NAMESPACE_SVG, "path"),
            document.createElementNS(NAMESPACE_SVG, "path")
        ];

        this._pathCallouts.forEach(x => {
            RenderManager.overlaySVG.appendChild(x);
            x.classList.add("livelabel", "callout");
            x.setAttribute("stroke-linecap", "round");
        });

        this._pathCallouts[0].setAttribute('stroke-width', 4.5);
        this._pathCallouts[1].setAttribute('stroke-width', 2);

        this._targetCallout = document.createElementNS(NAMESPACE_SVG, "circle");
        RenderManager.overlaySVG.appendChild(this._targetCallout);
        this._targetCallout.classList.add("livelabel", "callout");
        this._targetCallout.setAttribute("r", "3");
        this._targetCallout.setAttribute("stroke-width", 1);


        this._calloutDesired = new THREE.Vector2();
        this._calloutCurrent = new THREE.Vector2();
        this._calloutLerp = new THREE.Vector2();
        this._calloutOrigin = new THREE.Vector2();
        this._calloutTime = 0;
        this._desiredXYZ = new THREE.Vector3();

        this._lerpStartPosition = new THREE.Vector3();
        this._lerpStart = 0;
        this._gracePeriod = 0;
        this._lerpFinish = 0;
        this._isTransitioning = false;
        this._transitionFinishTime = 0;
    }

    getBoundingClientRect() {
        return this._g.getBoundingClientRect();
    }

    _calcFontSizeBase(width, height, fontSize = this.fontSize) { return ((fontSize / 1000) / (1 / Math.min(width, height))); }
    _calcPositionBase(width, height) { return [this.x, this.y]; }

    get textElement() { return this._textElement; }
    get g() { return this._g; }

    hide() { this.isVisible = false; }
    show() { this.isVisible = true; }

    setAttribute(attribute, value) {
        this._textElement.setAttribute(attribute, value);
    }

    getTranslatedContent() {
        return this.getTranslatedProperty("content")
    }

    getTranslatedProperty(property) {
        return `${property}_${Q3.language.toLocaleLowerCase()}` in this
            ? this[`${property}_${Q3.language.toLocaleLowerCase()}`]
            : this[property];
    }

    _applyContentBase(width, height, fontSize, isCallout) {
        if (width === undefined || height === undefined) {
            const style = this.parentLayer.domElement.getBoundingClientRect();
            width = style.width;
            height = style.height;
        }

        fontSize = !fontSize || isCallout ? this._calcFontSizeBase(width, height, isCallout ? 32 : undefined) : fontSize;

        this._textElement.textContent = this.getTranslatedContent();
        if (this._hoverTextEl) {
            this._textElement.classList.add('has-hover-text');
            this._hoverTextEl.innerHTML = this.getTranslatedProperty("hoverText");
        }

        /* DYNAMIC STROKE-WIDTH (because of zooming in editor) */

        this._g.style.fontSize = fontSize + "px";
        this._textElement.style.fontWeight = this.fontWeight;

        const textElement = this._textElement;

        const baseColor = this._highlighted
            ? '\#' + new THREE.Color(Q3.data.highlightColor || 0x77ff77).getHexString()
            : this.color;

        textElement.style.color = baseColor;

        textElement.style.textShadow = Utils.calcOutline(baseColor);


        const isVisible = this.isVisible && fontSize > 0;

        this._wasDrawn = isVisible;

    }

    setOutlineColor(color) {
        this._textElement.style.textShadow = getShadowString(color);
    }

    renderBase(width, height) {
        this._applyContentBase(width, height);

        const [x, y] = this._calcPositionBase(width, height);

        if (!USE_CSS_STYLE) {
            this.domElement.style.cssText += "left:" + x + "px; top:" + y + "px";
        } else {
            this._sheetRules.cssText = "left:" + x + "px; top:" + y + "px"
        }
    }

    get input() { return this._input; }

    createHoverText() {
        if (Q3.editMode) return;

        if (this.hoverText) {
            let hoverTextEl = document.createElement("div");
            hoverTextEl.classList.add("hover-text");
            hoverTextEl.textContent = this.getTranslatedProperty("hoverText");
            this._g.appendChild(hoverTextEl);
            this._hoverTextEl = hoverTextEl;
        }
    }

    setCalloutPath(x1, y1, x2, y2) {
        this._calloutOrigin.set(x2, y2);
        this._calloutDesired.set(x1, y1);
    }

    updateCalloutPath() {
        let x1 = this.x;
        let y1 = this.y;

        if (this.isActive && Q3.editMode && this._components) {
            const el = this._components.params.dom.children[0];
            const { width: _width } = RenderManager.getSize();

            const width = el.clientWidth;

            if (this.side === "left") { x1 = width + 5; }
            else { x1 = _width - width - 5; }

            y1 -= el.clientHeight * 0.5;
        }

        let offsetY = 0;

        if (!Q3.editMode) {
            const letterbox = getLetterbox();
            const { height } = RenderManager.getSize();

            offsetY = (height - letterbox.h) * 0.5 - letterbox.y;
        }

        const x2 = this._calloutOrigin.x, y2 = this._calloutOrigin.y + offsetY;

        this._pathCallouts[0].setAttribute("d", `M${x1} ${y1} L${x2} ${y2}`);
        this._pathCallouts[1].setAttribute("d", `M${x1} ${y1} L${x2} ${y2}`);

        this._targetCallout.setAttribute("cx", x2);
        this._targetCallout.setAttribute("cy", y2);
    }

    _getClickAction() {
        const uuid = this._liveLabel.uuid;
        const anim = SlideManager.currentSlide.animation[uuid];

        return anim ? anim.action : null;
    }

    updateUI() {
        if (!this._components) return;

        this._components.params.component.setState({});
    }

    hideExpansion() {
        Q3.expanded = null;
    }

    get clickable() {
        return Boolean(this._liveLabel._expandedLabelData.content || this.getTranslatedProperty("definition"))
    }

    _onClick(event) {
        if (!Q3.editMode) {
            Analytics.add({ type: "label-click", label: this.getTranslatedContent() })
        } else {
            if (Q3.activeEditorTab !== "AddLabels") {
                RenderManager.domElement.click(event);
                return;
            }

            fire("editLabelContent", this._liveLabel);
        }

        let definitionContent = this.getTranslatedProperty("definition")
        if (!Q3.editMode && (this._liveLabel._expandedLabelData.content || definitionContent)) {
            showModal({ heading: this.getTranslatedContent(), definition: definitionContent, content: `<div style="font-size: ${parseFloat(this._liveLabel._expandedLabelData.fontSize) / 24 + 'rem'}; line-height: ${this._liveLabel._expandedLabelData.lineHeight}">${this._liveLabel._expandedLabelData.content}</div>` });
        }

        if (!this._components) return;
        this._components.params.component.setState({});

        const action = this._getClickAction();

        if (action) {
            switch (action.type) {
                case "navigate":
                    SlideManager.setSlide(action.value);
                    break;
            }
            return;
        }

        if (Q3.editMode && !Q3.labels.live.isDrawingRegion) {
            Q3.selected = this._liveLabel;
            fire("selectchange");
        }
    }

    /**
     *
     * @param {MouseEvent} event
     */
    _onMouseOver(event) {
        RenderManager.setHighlightObjects([this._liveLabel.object]);
        Q3.labels.live.setHighlightLabel(this._liveLabel, true, true);
    }

    _onMouseLeave(event) {
        RenderManager.setHighlightObjects();
        Q3.labels.live.setHighlightLabel(this._liveLabel, false, true);
    }

    setBestDistance(distance) {
        const clip = Q3.labels.configs.clip_equation(distance);

        this.distanceMin = distance - clip;
        this.distanceMax = distance + clip;

        const keys = Object.keys(Q3.labels.configs.scales);
        let lastBound = Infinity;

        for (let i = keys.length - 1; i >= 0; i--) {
            const key = keys[i];
            const scale = Q3.labels.configs.scales[key];

            lastBound = typeof (scale.bound) === "number" ? scale.bound : lastBound;

            if (lastBound > clip) this.textScale = key;
            else break;
        }
    }

    _calcFontSize(width, height, isCallout, z = this.z) {
        const calcSize = fontSize => {
            const multiplier = Q3.browserCapabilities.isMobile ? 0.5 : 1;
            const val = ((fontSize * multiplier / 1000) / (1 / Math.min(width, height)))

            return val;
        };

        if (DISABLE_DISTANCE_CHECK) return calcSize((this.fontSizeMin + this.fontSize) * 0.5);
        else {
            const config = Q3.labels.configs.scales[this.textScale] || {};

            const min = this.distanceMin, max = this.distanceMax;
            const mid = (Math.abs(min) + Math.abs(max)) * 0.5;

            const renderMin = min * config.ratio + mid * (1 - config.ratio);
            const fontMin = config.min_size || 0, fontMax = config.size;

            const mapped = THREE.Math.mapLinear(z, max, renderMin, fontMin, fontMax);

            const fontSize = z >= min && z < max
                ? (!isCallout
                    ? THREE.Math.clamp(
                        mapped,
                        fontMin,
                        fontMax
                    )
                    : 32)
                : 0;

            const isActive = this.isActive;

            return (!isCallout && isActive)
                ? calcSize((this.fontSizeMin + this.fontSize) * 0.5)
                : calcSize(fontSize);
        }
    }

    get isActive() {
        const selectedRegion = Q3.labels.live.selectedRegion;
        const isActive = !!selectedRegion &&
            selectedRegion.uuid === this._liveLabel.uuid;

        return isActive;
    }

    setDynamic(isDynamic) {
        if (isDynamic) {
            if (this.domElement.classList.contains("static")) {
                this.domElement.classList.remove("static");
            }
        } else {
            if (!this.domElement.classList.contains("static")) {
                this.domElement.classList.add("static");
            }
        }
    }

    fadein() {
        if (!this.domElement.classList.contains("fadein")) {
            this.domElement.classList.remove("fadeout");
            this.domElement.classList.add("fadein");

            this._pathCallouts.forEach(x => {
                x.classList.remove("fadeout");
                x.classList.add("fadein");
            });

            this._targetCallout.classList.remove("fadeout");
            this._targetCallout.classList.add("fadein");

            if (this._input && this.isActive) { setTimeout(() => this._input.focus(), 200); }
        }
    }


    fadeout() {
        if (Q3.selected === this._liveLabel && this.isActive) return;
        if (!this.domElement.classList.contains("fadeout")) {
            this.domElement.classList.remove("fadein");
            this.domElement.classList.add("fadeout");

            if (this._input) this._input.blur();

            this._pathCallouts.forEach(x => {
                x.classList.remove("fadein");
                x.classList.add("fadeout");
            });

            this._targetCallout.classList.remove("fadein");
            this._targetCallout.classList.add("fadeout");
        }
    }

    prerender(width, height, isCallout, xyz) {
        const bbox = this._applyPrerender(width, height, isCallout, xyz);
        this._applyXYZ(width, height, isCallout);

        return bbox;
    }

    getApproximateBoundingBox(width, height, isCallout, xyz) {
        const { x, y, z } = xyz;

        const fontDesired = Math.round(this._calcFontSize(width, height, isCallout, z));
        const fontNext = Math.abs(fontDesired - this._lastFontSize) < 5
            ? THREE.Math.lerp(this._lastFontSize, fontDesired, 0.05)
            : fontDesired;

        const fontSize = Math.round(fontNext);

        const fontMultiplier = fontSize / 100 * (Q3.editMode ? 1.15 : 0.95);
        const fontHeight = FONT_HEIGHT * fontMultiplier;
        const fontWidth = this.getTranslatedContent().split('').reduce((accumulated, char) => {
            const size = (CHAR_SIZES[char] || CHAR_SIZES['a']) * fontMultiplier;
            return accumulated + size;
        }, 0);

        const _w = fontWidth, _h = fontHeight;
        let _x = Math.min(Math.max(0, x - fontWidth * 0.5), width - _w);
        let _y = Math.min(Math.max(0, y - fontHeight * 0.5), height - _h);


        if (isCallout) {
            _x *= RenderManager.pixelRatio;
            _y *= RenderManager.pixelRatio;
        }

        if (!Q3.editMode) {
            _x += _w * 0.5;
            _y += _h * 0.5;
        }

        const newBounds = new DOMRect(_x, _y, _w, _h);

        return newBounds;
    }

    _applyPrerender(width, height, isCallout, xyz) {
        const parentBounds = RenderManager.overlay2dBounds;
        const { x, y, z } = xyz;

        if (Q3.editMode) {
            const foreign = this._foreignObject, el = this.domElement;
            const isActive = this.isActive;

            if (isActive || this.getTranslatedContent().length === 0) {
                el.style.display = "block";

                const fx = el.clientWidth * 0.5;
                const fy = el.clientHeight * 0.5;

                if (this.domElement !== this.domElement.parentNode.lastElementChild) {
                    this.domElement.parentNode.appendChild(this.domElement);
                }

                const _w = fx * 2, _h = fy * 2;
                const _x = Math.min(Math.max(0, x - fx), width - _w);
                const _y = Math.min(Math.max(0, y - fy), height - _h);

                this._svg.setAttribute("width", _w);
                this._svg.setAttribute("height", _h);

                if (!USE_CSS_STYLE) {
                    this.domElement.style.cssText += "left:" + _x + "px; top:" + _y + "px";
                } else {
                    this._sheetRules.cssText = "left:" + _x + "px; top:" + _y + "px"
                }


                return new DOMRect(parentBounds.min.x + _x, parentBounds.min.y + _y, _w, _h);
            } else {
                foreign.style.display = "none";
                this._svg.style.display = "unset";
            }
        }

        const fontDesired = Math.round(this._calcFontSize(width, height, isCallout, z));
        const fontNext = Math.abs(fontDesired - this._lastFontSize) < 5
            ? THREE.Math.lerp(this._lastFontSize, fontDesired, 0.05)
            : fontDesired;

        this._lastFontSize = fontNext;
        const fontSize = Math.round(fontNext);

        const fontMultiplier = fontSize / 100 * 1.15;
        const fontHeight = FONT_HEIGHT * fontMultiplier;
        const fontWidth = this.getTranslatedContent().split('').reduce((accumulated, char) => {
            const size = (CHAR_SIZES[char] || CHAR_SIZES['a']) * fontMultiplier;
            return accumulated + size;
        }, 0);

        const _w = !isCallout ? fontWidth : width * 0.20, _h = fontHeight;
        const _x = Math.min(Math.max(0, x - fontWidth * 0.5), width - _w);
        const _y = Math.min(Math.max(0, y - fontHeight * 0.5), height - _h);

        const newBounds = new DOMRect(parentBounds.min.x + _x, parentBounds.min.y + _y, _w, _h);

        this._svg.setAttribute("width", _w);
        this._svg.setAttribute("height", _h);

        if (!USE_CSS_STYLE) {
            this.domElement.style.cssText += "left:" + _x + "px; top:" + _y + "px";
        } else {
            this._sheetRules.cssText = "left:" + _x + "px; top:" + _y + "px"
        }

        if (!isCallout) {
            this._g.setAttribute("transform", `translate(${_w * 0.5}, ${_h * 0.75})`);
        }

        return newBounds;
    }

    setXYZ(point) {
        this.x = point.x;
        this.y = point.y;
        this.z = point.z;
    }

    setDesiredXYZ(point) {
        const desiredXYZChanged = !this._desiredXYZ.equals(point);

        this._lerpStartPosition.set(this.x, this.y, this.z);
        this._desiredXYZ.copy(point);

        const curTime = new Date().getTime();

        this._lerpStart = curTime;
        this._gracePeriod = curTime + 10;
        this._lerpFinish = this._gracePeriod + 40;

        if (desiredXYZChanged) {
            this._isTransitioning = true;
            this._transitionFinishTime = this._lerpFinish;
        }
    }

    updateTransition() {
        const curTime = new Date().getTime();

        this._isTransitioning = curTime <= this._transitionFinishTime;

        if (curTime >= this._gracePeriod && curTime <= this._lerpFinish) {
            const mapped = THREE.Math.mapLinear(curTime, this._gracePeriod, this._lerpFinish, 0, 1);
            const lerper = new THREE.Vector3().lerpVectors(this._lerpStartPosition, this._desiredXYZ, mapped);

            this.x = lerper.x;
            this.y = lerper.y;
            this.z = lerper.z;

            const { width, height } = RenderManager.getSize();

            this.render(width, height, true);
        }
    }

    get isTransitioning() {
        return this._isTransitioning;
    }

    _applyXYZ(width, height, isCallout) {
        const x = this.x, y = this.y;

        if (this._components && Q3.editMode) {
            const isActive = this.isActive;

            if (isActive || this.getTranslatedContent().length === 0) {
                const el = this._components.params.dom.children[0];
                const fx = el.clientWidth * 0.5;
                const fy = el.clientHeight * 0.5;

                const _w = fx * 2, _h = fy * 2;
                let _x = Math.min(Math.max(0, x - fx), width - _w);
                const _y = Math.min(Math.max(0, y - fy), height - _h);

                if (isCallout) {
                    if (this.side === "left") { _x += _w * 0.5 + 5; }
                    else { _x = width - _w - 5; }
                }

                if (!USE_CSS_STYLE) {
                    this.domElement.style.cssText += "left:" + _x + "px; top:" + _y + "px";
                } else {
                    this._sheetRules.cssText = "left:" + _x + "px; top:" + _y + "px"
                }

                return;
            }
        }

        const fontSize = Math.round(this._lastFontSize);

        const fontMultiplier = fontSize / 100 * 1.15;
        const fontHeight = FONT_HEIGHT * fontMultiplier;
        const fontWidth = this.getTranslatedContent().split('').reduce((accumulated, char) => {
            const size = (CHAR_SIZES[char] || CHAR_SIZES['a']) * fontMultiplier;
            return accumulated + size;
        }, 0);

        let _x, _y;

        if (!isCallout) {
            const _w = !isCallout ? fontWidth : width * 0.20, _h = fontHeight;

            _x = Math.min(Math.max(0, x - fontWidth * 0.5), width - _w);
            _y = Math.min(Math.max(0, y - fontHeight * 0.5), height - _h);
        } else {
            _x = x;
            _y = y;
        }

        if (!USE_CSS_STYLE) this.domElement.style.cssText += "left:" + _x + "px; top:" + _y + "px";
        else this._sheetRules.cssText = "left:" + _x + "px; top:" + _y + "px";
    }

    _applyContent(width, height, fontSize, isCallout) {
        this._applyContentBase(width, height, fontSize, isCallout);

        if (isCallout) {
            this._pathCallouts.forEach(x => {
                // if (this._wasDrawn) {
                x.style.display = this._wasDrawn ? "inline-block" : "none";
                // }
            });

            // if (this._wasDrawn) {
            this._targetCallout.style.display = this._wasDrawn ? "inline-block" : "none";
            // }
        } else {
            this._pathCallouts.forEach(x => {
                x.style.display = "none";

            });
            this._targetCallout.style.display = "none";
        }
    }

    hidePaths() {
        this._pathCallouts.forEach(x => x.style.display = "none");
        this._targetCallout.style.display = "none";
    }

    render(width, height, isCallout) {

        let slideData = {
            textColor: this.color,
            backgroundOpacity: this.backgroundOpacity,
            paddingHorizontal: this.paddingHorizontal,
            paddingVertical: this.paddingVertical,
            backgroundRadius: this.backgroundRadius,
            backgroundColor: this.backgroundColor
        };

        SlideManager.currentSlide.labels = SlideManager.currentSlide.labels || {};
        SlideManager.currentSlide.labels.live = SlideManager.currentSlide.labels.live || {};
        SlideManager.currentSlide.labels.live[this._liveLabel.uuid] = SlideManager.currentSlide.labels.live[this._liveLabel.uuid] || {};

        slideData = Object.assign(slideData, SlideManager.currentSlide.labels.live[this._liveLabel.uuid]);

        this.color = slideData.textColor;
        this.backgroundOpacity = slideData.backgroundOpacity;
        this.paddingHorizontal = slideData.paddingHorizontal;
        this.paddingVertical = slideData.paddingVertical;
        this.backgroundRadius = slideData.backgroundRadius;
        this.backgroundColor = slideData.backgroundColor;

        Object.assign(SlideManager.currentSlide.labels.live[this._liveLabel.uuid], slideData);

        // super.render(width, height);

        this._applyXYZ(width, height, isCallout);

        const fontSize = Math.round(this._lastFontSize);

        this._applyContent(width, height, fontSize, isCallout);
        this.domElement.style.cursor = this.clickable ? "pointer" : "default";
        this._textElement.style.color = this._highlighted
            ? '\#' + new THREE.Color(Q3.data.highlightColor || 0x77ff77).getHexString()
            : slideData.textColor;

        if (isCallout) {
            if (!this.domElement.classList.contains("callout"))
                this.domElement.classList.add("callout");
        } else {
            if (this.domElement.classList.contains("callout"))
                this.domElement.classList.remove("callout");
        }

        if (Q3.editMode || this._liveLabel._expandedLabelData.content) {
            this._g.style.cursor = "pointer";
        } else {
            this._g.style.cursor = "unset";
            // this._g.style.pointerEvents = "none";
            this._g.style.userSelect = "none";
        }

        this._g.style.borderRadius = slideData.backgroundRadius + "px";
        this._g.style.padding = `${slideData.paddingVertical}em ${slideData.paddingHorizontal}em`;

        let styles = { background: "unset", borderColor: "transparent" };
        if (Q3.editMode && this._liveLabel === Q3.selected) {
            // styles.background = "rgba(0,0,0,0.2)";
            styles.borderColor = "#4afcd0"
        }
         /*if (this._highlighted)*/ {
            const { r, g, b } = tmpColor.setStyle(slideData.backgroundColor);
            styles.background = `rgba(${r * 255},${g * 255},${b * 255},${this._highlighted ? 1 : slideData.backgroundOpacity})`;
        }
        Object.assign(this._g.style, styles);

        this.domElement.style.zIndex = this._highlighted ? 2 : 1;

        if (!Q3.editMode && !this._liveLabel._expandedLabelData.content) {
            this._icon.style.display = "none";
        }

        const isActive = this.isActive;

        if (isActive || (Q3.quizActive && Q3.quizActive.uuid === this.uuid)) {
            this._textElement.setAttribute("display", "none");
        } else {
            this._textElement.setAttribute("display", "unset");
        }

        if (isCallout) {
            this.updateCalloutPath();

            const strokeColor = Utils.hexToComplimentary(this.color);
            this._pathCallouts[1].setAttribute("stroke", strokeColor);
            this._pathCallouts[0].setAttribute("stroke", this.color);

            this._targetCallout.setAttribute("fill", strokeColor);
            this._targetCallout.setAttribute("stroke", this.color);
        }
    }
}

const computeFontSize = (function () {
    const lastSize = new THREE.Vector2();

    return function computeFontSize() {
        let parent = RenderManager.overlay2d;

        while (parent && parent !== document.body)
            parent = parent.parentElement;

        if (!parent) return;

        const { width, height } = RenderManager.getSize();

        if (lastSize.width === width && lastSize.height === height) return;

        lastSize.set(width, height);

        if (!TEXT_ELEMENT) {
            let meshLabel = new MeshLabel(new THREE.Mesh(), THREE.Math.generateUUID());
            let liveLabel = meshLabel._labels[0];
            TEXT_ELEMENT = liveLabel._element;
            TEXT_ELEMENT.fontSize = 100;
            TEXT_ELEMENT.content = "--";
            TEXT_ELEMENT.domElement.classList.remove("livelabel");

            RenderManager.overlay2d.appendChild(TEXT_ELEMENT.domElement);
            TEXT_ELEMENT.domElement.style.visibility = "hidden";
            TEXT_ELEMENT.domElement.setAttribute("measurement-element", "");
            TEXT_ELEMENT.domElement.style.pointerEvents = "none";
        }

        TEXT_ELEMENT.domElement.style.visibility = "hidden";
        TEXT_ELEMENT.fadeout();
        TEXT_ELEMENT.content = "--";
        TEXT_ELEMENT.renderBase(width, height);
        TEXT_ELEMENT._textElement.style.fontSize = "100px";

        const { width: bw, height: bh } = TEXT_ELEMENT.getBoundingClientRect();

        FONT_HEIGHT = bh * 1.15;

        const characters = " abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.,;-0123456789".split('');

        characters.forEach(char => {
            TEXT_ELEMENT.content = '-' + char + '-';
            TEXT_ELEMENT.renderBase(width, height);
            TEXT_ELEMENT._textElement.style.fontSize = "100px";

            const { width: cw } = TEXT_ELEMENT.getBoundingClientRect();

            CHAR_SIZES[char] = (cw - bw) * 1.15;
        });
    }
})();

export default TextLiveLabel;
export { TextLiveLabel, computeFontSize }
